import { createFileRoute, Link } from '@tanstack/react-router';

import { DestinationPage } from '../../pages/destinations';
import { useSession } from '../../entities/session';

export const Route = createFileRoute('/_shell/destinations/$destinationId')({
  component: function DestinationRoute() {
    const { destinationId } = Route.useParams();
    const session = useSession();

    return (
      <DestinationPage
        destinationId={destinationId}
        timeZone={session.data?.preferences.timezone}
        breadcrumb={<Link to="/destinations">Destinations</Link>}
      />
    );
  },
});
